import { RunnerActor } from '@/state/RunnerStateMachine'
import { PlayerInputEvent } from '@/webgl/runner/core/GameEvents'
import { BonusType } from '@/webgl/runner/entities/BonusEntity'
import { PlayerEntity } from '@/webgl/runner/entities/PlayerEntity'
import { TimeEntity } from '@/webgl/runner/entities/Time'
import GameWorld from '@/webgl/runner/GameWorld'
import { ISystem } from '@/webgl/runner/interfaces/ISystem'

const MOVE_SPEED = 2

export default class PlayerSystem implements ISystem {
  private world: GameWorld

  player: PlayerEntity
  actor: RunnerActor

  constructor(world: GameWorld) {
    this.world = world

    this.player = this.world.player
    this.player.node.y = 0.5

    this.world.events.PlayerInput.on(this.onPlayerInput)
  }

  dispose(): void {
    this.world.events.PlayerInput.off(this.onPlayerInput)
  }

  private onPlayerInput = (inputEvt: PlayerInputEvent) => {
    if (this.world.state.value.paused) return
    let direction = inputEvt.direction
    if (this.world.isBonusActive(BonusType.Confusion)) {
      this.world.events.StatusTrigger.emit('confusion')
      direction *= -1
    }
    if (direction === -1) this.moveLeft()
    if (direction === 1) this.moveRight()
  }

  private moveLeft() {
    if (this.player.locked) return
    if (this.player.lane <= -1) return
    this.player.lane -= 1
    this.player.direction = -1
    this.world.state.setLane(this.player.lane)
  }

  private moveRight() {
    if (this.player.locked) return
    if (this.player.lane >= 1) return
    this.player.lane += 1
    this.player.direction = 1
    this.world.state.setLane(this.player.lane)
  }

  update(time: TimeEntity) {
    if (this.player.locked) return
    const LANE_SIZE = this.world.settings.LANE_SIZE
    const target = LANE_SIZE * this.player.lane

    if (this.player.node.x == target) return

    this.player.node.x += time.unscaledDeltaTime * MOVE_SPEED * this.player.direction

    if (this.player.direction == -1 && target - this.player.node.x > 0) {
      this.player.node.x = target
      this.player.visualLane = this.player.lane
    }

    if (this.player.direction == 1 && this.player.node.x - target > 0) {
      this.player.node.x = target
      this.player.visualLane = this.player.lane
    }
  }
}
